export const createHref = (
  pathname?: string,
  searchParams?: Record<string, string>,
) => {
  const origin = window.origin;

  let href = origin;

  if (pathname) {
    const parsedPathname = pathname === "/" ? "" : pathname;
    href += parsedPathname;
  }

  if (!searchParams) {
    return href;
  }

  const parsedSearchParams = new URLSearchParams(searchParams).toString();

  if (parsedSearchParams) {
    href += `?${parsedSearchParams}`;
  }

  return href;
};
